import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageHero = ({ title, subtitle, breadcrumb }) => (
  <section className="relative bg-gradient-to-r from-[#2C5F66] to-[#244e54] py-20 md:py-28">
    <div className="absolute inset-0 opacity-10" style={{ backgroundImage: 'radial-gradient(circle at 20% 30%, white 1px, transparent 1px), radial-gradient(circle at 70% 60%, white 1px, transparent 1px)', backgroundSize: '60px 60px' }} />
    <div className="relative max-w-6xl mx-auto px-6 text-center">
      <h1 className="text-white text-4xl md:text-6xl font-extrabold tracking-tight">{title}</h1>
      {subtitle && <p className="text-white/80 mt-5 text-lg max-w-3xl mx-auto">{subtitle}</p>}
      {breadcrumb && (
        <nav className="mt-6 flex items-center justify-center gap-1 text-white/70 text-sm">
          <Link to="/" className="hover:text-[#D9A04A]">Home</Link>
          <ChevronRight size={14} />
          <span className="text-[#D9A04A] font-semibold">{breadcrumb}</span>
        </nav>
      )}
    </div>
  </section>
);

export default PageHero;
